import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

// ── Service SVG icons ─────────────────────────────────────────────────────

const IconBox = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
    <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
    <line x1="12" y1="22.08" x2="12" y2="12"/>
  </svg>
);

const IconWrench = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
  </svg>
);

const IconShield = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    <polyline points="9 12 11 14 15 10"/>
  </svg>
);

const IconGear = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06-.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </svg>
);

const IconMonitor = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="2" y="3" width="20" height="14" rx="2"/>
    <path d="M8 21h8M12 17v4"/>
  </svg>
);

const IconCheck = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

// ── Page ───────────────────────────────────────────────────────────────────

const Home: React.FC = () => {
  return (
    <div className="home">

      {/* Hero */}
      <section className="hero" style={{ backgroundImage: "url('/images/home-page.jpg')" }}>
        <div className="hero-content">
          <div className="hero-eyebrow">Desde 1994 — Zapopan, Jalisco</div>
          <h1>Soluciones Integrales<br />de Pesaje Industrial</h1>
          <p>
            Diseñamos, integramos y damos servicio a sistemas de pesaje y automatización
            para la industria mexicana.
          </p>
          <div className="hero-actions">
            <Link to="/productos" className="btn-primary">Ver Productos</Link>
            <Link to="/contacto" className="btn-outline">Contáctenos</Link>
          </div>
        </div>
      </section>

      {/* Floating stats strip */}
      <section className="stats-strip">
        <div className="stats-grid">
          <div className="stat">
            <span className="stat-number">+30</span>
            <span className="stat-label">Años de experiencia</span>
          </div>
          <div className="stat">
            <span className="stat-number">15</span>
            <span className="stat-label">Categorías de producto</span>
          </div>
          <div className="stat">
            <span className="stat-number">3</span>
            <span className="stat-label">Marcas líderes</span>
          </div>
          <div className="stat">
            <span className="stat-number">Nacional</span>
            <span className="stat-label">Cobertura de servicio</span>
          </div>
        </div>
      </section>

      {/* Quiénes Somos */}
      <section className="about-strip">
        <div className="container about-strip-grid">
          <div className="about-strip-text">
            <h2>Especialistas en Pesaje y Automatización</h2>
            <p>
              Somos <strong>Automatización Básculas y Control, S.A. de C.V.</strong>, con sede en Zapopan,
              Jalisco. Llevamos más de 30 años brindando soluciones de pesaje industrial: desde la venta
              e instalación de equipo hasta el diseño de sistemas automatizados a la medida de cada proceso.
            </p>
            <p>
              Contamos con técnicos certificados para instalación, calibración y mantenimiento preventivo
              y correctivo en toda la República Mexicana. Representamos marcas líderes mundiales y
              respaldamos cada equipo con soporte técnico directo.
            </p>
            <Link to="/quienes-somos" className="btn-secondary">Conozca nuestra historia</Link>
          </div>
          <div className="about-strip-highlights">
            <div className="highlight-item">
              <span className="highlight-icon"><IconCheck /></span>
              <span>Técnicos certificados en sitio</span>
            </div>
            <div className="highlight-item">
              <span className="highlight-icon"><IconCheck /></span>
              <span>Calibración y verificación metrológica (EMA M70)</span>
            </div>
            <div className="highlight-item">
              <span className="highlight-icon"><IconCheck /></span>
              <span>Cobertura en toda la República</span>
            </div>
            <div className="highlight-item">
              <span className="highlight-icon"><IconCheck /></span>
              <span>Sistemas integrados a la medida</span>
            </div>
            <div className="highlight-item">
              <span className="highlight-icon"><IconCheck /></span>
              <span>Respaldo técnico y garantía en equipos</span>
            </div>
          </div>
        </div>
      </section>

      {/* Lo que hacemos */}
      <section className="services-section">
        <div className="container">
          <h2>Lo que hacemos</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-card-icon"><IconBox /></div>
              <h3>Venta de Equipo</h3>
              <p>
                Indicadores de peso, celdas de carga, básculas industriales y más.
                Equipos de calidad con respaldo técnico incluido.
              </p>
              <Link to="/productos" className="service-link">Ver catálogo</Link>
            </div>
            <div className="service-card">
              <div className="service-card-icon"><IconWrench /></div>
              <h3>Mantenimiento y Reparación</h3>
              <p>
                Servicio preventivo y correctivo en sitio. Reparación y diagnóstico
                por técnicos especializados en equipos de pesaje.
              </p>
              <Link to="/servicios" className="service-link">Ver servicios</Link>
            </div>
            <div className="service-card">
              <div className="service-card-icon"><IconShield /></div>
              <h3>Calibración y Verificación</h3>
              <p>
                Laboratorio acreditado ante la <strong>EMA (M70)</strong> para calibración
                de básculas y pesas patrón. Verificación por Unidad Verificadora Acreditada.
              </p>
              <Link to="/servicios" className="service-link">Ver servicios</Link>
            </div>
            <div className="service-card">
              <div className="service-card-icon"><IconGear /></div>
              <h3>Automatización Industrial</h3>
              <p>
                Diseñamos e integramos sistemas a la medida: bandas transportadoras,
                dosificación de ingredientes y software de control de pesaje.
              </p>
              <Link to="/automatizacion" className="service-link">Ver soluciones</Link>
            </div>
            <div className="service-card">
              <div className="service-card-icon"><IconMonitor /></div>
              <h3>Software de Pesaje</h3>
              <p>
                Sistemas que conectan el pesaje con su proceso productivo: integración
                con ERP, trazabilidad y generación de reportes.
              </p>
              <Link to="/software" className="service-link">Ver software</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Marcas */}
      <section className="brands-section">
        <div className="container">
          <h2>Marcas que Representamos</h2>
          <p className="brands-subtitle">
            Trabajamos con fabricantes líderes en tecnología de pesaje a nivel mundial
          </p>
          <div className="brands-grid">
            <div className="brand-badge brand-badge--dark">
              <img src="/awtx-logo.svg" alt="Avery Weigh-Tronix" className="brand-logo" />
              
            </div>
            <div className="brand-badge brand-badge--dark">
              <img src="/rice-lake-logo.png" alt="Rice Lake" className="brand-logo" />
            </div>
            <div className="brand-badge brand-badge--dark">
              <img src="/dillon-logo.svg" alt="Dillon" className="brand-logo brand-logo--sm" />
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="home-cta">
        <div className="container">
          <h2>¿Necesita una solución de pesaje?</h2>
          <p>
            Nuestros especialistas le asesoran sin compromiso. Contáctenos y encuentre
            la solución adecuada para su proceso.
          </p>
          <div className="cta-actions">
            <Link to="/contacto" className="btn-primary">Solicitar Información</Link>
            <a href="tel:+523336349050" className="btn-outline">Llamar: (33) 3634-9050</a>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;
